import { Action } from 'store/store';
import omitUndefined from 'utils/omitUndefined';
import { WidgetTypeActionPayload, WidgetActionType } from '../actions';
import { WidgetType } from '../../WidgetType';
import { WidgetClearStreamDataAction } from '../stream/actions';

export interface WidgetReceiveRpcStreamResponseActionPayload<TResponse>
    extends WidgetTypeActionPayload {
    response: TResponse;
}

export type WidgetReceiveRpcStreamResponseAction<TResponse> = Action<
    WidgetActionType.WIDGET_RECEIVE_RPC_STREAM_RESPONSE,
    WidgetReceiveRpcStreamResponseActionPayload<TResponse>
>;

export function createReceiveRpcResponseAction<TResponse>(
    widgetType: WidgetType
) {
    return (
        widgetKey: string,
        response: TResponse
    ): WidgetReceiveRpcStreamResponseAction<TResponse> => {
        if (!widgetType || !widgetKey) {
            throw new Error('No widget type or widget key received');
        }
        return {
            type: WidgetActionType.WIDGET_RECEIVE_RPC_STREAM_RESPONSE,
            payload: omitUndefined({
                widgetType,
                widgetKey,
                response,
            }),
        };
    };
}

export type WidgetRpcStreamAction<T> =
    | WidgetClearStreamDataAction
    | WidgetReceiveRpcStreamResponseAction<T>;
